import { Visibility } from '../visibility/visibility.types';

export type Translation = {
  body: string;
  langCode: string;
};

export type TemplateOpenQuestionOption = {
  id: number;
  translations: Translation[];
  position: number;
  disqualifyReasonId: null | number;
  options?: {
    kind?: 'yes' | 'no';
  };
};

export type TemplateOptions = {
  length?: number;
  currency?: string;
};

export type TemplateOpenQuestionsItem = {
  id?: number;
  kind: OpenQuestionKind;
  isKnockoutQuestion: boolean;
  openQuestionOptions: TemplateOpenQuestionOption[];
  openQuestionTemplateId: number;
  translations: Translation[];
  position?: number;
  required: boolean;
  options?: TemplateOptions;
  visibility?: Visibility;
  visible: boolean;
};

export type OpenQuestionsTemplate = {
  assignedOffersCount: number;
  category: string;
  custom: boolean;
  default: boolean;
  id: number;
  position: number;
  title: string;
  name: string;
  updatedAt: string;
  openQuestions: TemplateOpenQuestionsItem[];
  options?: { length: number };
};

export type OpenQuestionsTemplatePayload = {
  id?: number;
  category: string;
  title: string;
};

export type SaveQuestionPayload = {
  form: any;
  templateId: number;
  questionId?: number;
  offerId?: number;
};

export enum OpenQuestionKind {
  TextSingleLine = 'string',
  TextMultiLine = 'text',
  Boolean = 'boolean',
  SingleChoice = 'single_choice',
  MultiChoice = 'multi_choice',
  Date = 'date',
  Number = 'number',
  Salary = 'salary',
  Video = 'video',
  File = 'file',
  InfoBox = 'infobox',
  Legal = 'legal',
}
